import React, { useState } from 'react';
import { Space } from 'antd';
import styles from './index.module.scss';
import { TimeActive } from '../index';

// 定义组件属性接口
interface SwitchDateProps {
  options: { label: string; value: TimeActive }[];
  defaultValue?: TimeActive;
  onChange?: (value: TimeActive) => void;
  className?: string;
}

// 定义组件
const SwitchDate: React.FC<SwitchDateProps> = ({ defaultValue, options, onChange, className }) => {
  const [activeKey, setActiveKey] = useState<TimeActive | undefined>(defaultValue);

  const handleDateChange = (value: TimeActive) => {
    setActiveKey(value);
    onChange?.(value);
  };

  return (
    <Space size={8} className={className}>
      {options.map((item, index) => (
        <div
          key={index}
          className={`${styles.dateBtn} ${activeKey === item.value && styles.active}`}
          onClick={() => handleDateChange(item.value)}
        >
          {item.label}
        </div>
      ))}
    </Space>
  );
};

export default SwitchDate;
